module.exports = __webpack_public_path__ + "static/media/omniva.cf2716bc.svg";